import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

import { ExportInFile, NoPermission } from '~/components';
import { getTransactionsExportResult } from '~/api/transactions';
import {
  useCreateExportTask,
  useExportStatus,
  useTransactionExportCheck,
} from '~/hooks/transactions';
import { usePermissions } from '~/hooks';
import { PageList } from '~/layout';
import { Transaction } from '~/types';
import Filters from './Filters';
import TransactionsTable from './TransactionsTable';
// eslint-disable-next-line import/named
import { Paths } from '~/types/api/generatedApiClient';
import TransactionShow from './TransactionShow';

const Transactions: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('transactions');

  const [data, setData] = useState<Paths.GetTransactionListByProfileId.Responses.$200>({
    cursors: {},
    transactions: [],
  });

  const [open, setOpen] = useState(false);
  const [showData, setShowData] = useState<Transaction | null>(null);
  const handleOpen = (transaction: Transaction) => {
    setOpen(true);
    setShowData(transaction);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const hasAccess = usePermissions('business.transactions.list');
  if (!hasAccess) return <NoPermission />;
  return (
    <>
      <TransactionShow open={open} data={showData} onClose={handleClose} />
      <PageList
        header={{
          heading: t('transactions'),
          showSearch: false,
        }}
        filters={<Filters />}
        table={<TransactionsTable data={data} setData={setData} handleOpen={handleOpen} />}
        hideDisplayMode
        add={
          <ExportInFile
            getExportResult={getTransactionsExportResult}
            useExportCheck={useTransactionExportCheck}
            useCreateExportTask={useCreateExportTask}
            useExportStatus={useExportStatus}
            filePrefix="transactions"
          />
        }
      />
    </>
  );
};

export default Transactions;
